import * as demo from '../services/demo';
import { ActionTypes } from '../types/action-types';

export const showResult = (show: boolean = false) => ({
    type: ActionTypes.DEMO_SHOW_RESULT,
    value: show
});

export const me = (token: string) => async dispatch => {
    dispatch(showResult(true));
    dispatch({
        type: ActionTypes.DEMO_DATA_PENDING
    });
    const user = await demo.me(token);
    dispatch({
        type: ActionTypes.DEMO_DATA_READY,
        value: user
    })
};




// WEBPACK FOOTER //
// ./src/actions/demo.ts